import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Footer from '../components/Footer';

const interventionStrands = [
  {
    title: 'Stabilisation & Safety',
    points: [
      'Crisis planning & daily support: Safety mapping and regulation routines implemented in partnership with the residential team.',
      'Psychoeducation: Guidance for young people, carers, and schools on trauma responses and effective coping strategies.',
      'Rapid clinical access: Immediate consultation available through our on-call clinical rota when risk levels change.'
    ]
  },
  {
    title: 'Therapeutic Interventions',
    points: [
      'Individual therapy: Evidence-based one-to-one interventions, including CBT, DBT-informed skills, ACT, and creative therapies.',
      'Family & network support: Sessions designed to rebuild relationships and prepare young people for future transitions.',
      'Group work: Structured modules addressing identity, relationships, online safety, substance misuse, and resilience.'
    ]
  },
  {
    title: 'Integration with Daily Life',
    points: [
      'Practical application: Clinical walkthroughs to embed assessment and formulation into everyday care.',
      'Staff support: Reflective practice sessions to ensure staff feel confident and supported.',
      'Collaborative tracking: Shared dashboards to monitor goals and progress across the entire care team.'
    ]
  }
];

const TherapyInterventions = () => (
  <div className="TherapyInterventions bg-white">
    <Header />
    <div className="mt-32 sm:mt-36 lg:mt-32">
      <Hero
        image="/assets/images/interventions.jpeg"
        heightClass="min-h-[50vh] sm:min-h-[60vh] lg:min-h-[70vh]"
        position="center"
      />

      <section className="bg-white py-16 px-6 lg:px-12">
      <div className="max-w-6xl mx-auto">
        <p className="text-sm uppercase tracking-[0.3em] text-[#2f4c74] mb-4">Therapy Services</p>
        <h1 className="text-4xl md:text-6xl font-light text-[#2b3d57] mb-6">Interventions</h1>
        <p className="text-xl text-[#2b3d57] max-w-4xl leading-relaxed">
          Our Multi-Disciplinary Assessment and Therapy team delivers interventions that blend clinical expertise with
          innovative, child-centred approaches. By integrating goal-focused therapy into daily routines, we create an
          environment where young people feel safe, heard, and empowered to make progress at their own pace.
        </p>
      </div>
    </section>

    <section className="bg-[#f2f4f7] py-16 px-6 lg:px-12">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-8">
        {interventionStrands.map((strand) => (
          <div key={strand.title} className="bg-white rounded-lg shadow-sm p-8">
            <h2 className="text-2xl font-light text-[#2b3d57] mb-4">{strand.title}</h2>
            <ul className="space-y-3 text-[#2b3d57] list-disc list-inside">
              {strand.points.map((point) => (
                <li key={point}>{point}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>

    <section className="py-16 px-6 lg:px-12 bg-white">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-stretch">
        <div className="bg-[#e9edf3] rounded-lg p-8">
          <h3 className="text-3xl font-light text-[#2b3d57] mb-4">Measuring Progress</h3>
          <p className="text-[#2b3d57] leading-relaxed">
            We track progress using session-by-session outcome tools, goal attainment scaling, and customised wellbeing
            indicators to capture meaningful change. Insights are shared during reviews, providing commissioners with
            clear evidence of the placement's impact.
          </p>
        </div>
        <div className="bg-[#2b3d57] text-white rounded-lg p-8">
          <h3 className="text-3xl font-light mb-4">Flexible Delivery</h3>
          <p className="mb-6 leading-relaxed">
            Interventions are delivered in therapy rooms, schools, community settings, or online, tailored to each young
            person's needs. We adjust duration and frequency, including offering intensive programmes after periods of
            crisis, to ensure support is timely and effective.
          </p>
          <a
            href="mailto:Info@testacare.co.uk"
            className="inline-flex items-center justify-center rounded-full border-2 border-white px-6 py-2 text-white hover:bg-white hover:text-[#2b3d57] transition"
          >
            Refer a young person
          </a>
        </div>
      </div>
    </section>

      <Footer />
    </div>
  </div>
);

export default TherapyInterventions;



